import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { ScheduledOutageCard } from './ScheduledOutageCard';
import { AccountParams } from '../../__generated__/pge-types';
import { usePspsHandler } from '../outage_v2/hooks/usePspsHandler';
import { PspsDetails, PspsStatus } from '../outage_v2/types';

type PublicSafetyPowerShutoffDetailsProps = {
  accountParams: AccountParams[];
  isAccountSelected: boolean;
  selectedAccount?: any;
};

export const PublicSafetyPowerShutoffDetails = ({
  selectedAccount,
}: PublicSafetyPowerShutoffDetailsProps) => {
  const { t, inlineRichT } = useTranslation();
  const { getPspsStatus, matchedZones } = usePspsHandler();
  const [pspsDetails, setPspsDetails] = useState<PspsDetails | undefined>(
    undefined,
  );

  useEffect(() => {
    if (selectedAccount && selectedAccount?.pspsOutage?.outageZone) {
      const status = getPspsStatus(selectedAccount?.pspsOutage?.outageZone);

      if (status) {
        setPspsDetails(status);
      } else {
        setPspsDetails(undefined);
      }
    }
  }, [selectedAccount, matchedZones]);

  let title: string = '';
  let description: string = '';

  switch (pspsDetails?.status) {
    case PspsStatus.InProgress:
      title = 'PSPS_IN_PROGRESS';
      description = 'HIGH_FIRE_RISK_CONDITIONS';
      break;

    case PspsStatus.Warning:
      title = 'PSPS_WARNING';
      description = 'PSPS_WARNING_DESCRIPTION';
      break;

    case PspsStatus.Likely:
      title = 'PSPS_LIKELY';
      description = 'PSPS_LIKELY_DESCRIPTION';
      break;

    case PspsStatus.Imminent:
      title = 'PSPS_IMMINENT';
      description = 'PSPS_IMMINENT_DESCRIPTION';
      break;

    case PspsStatus.Restoration:
      title = 'RESTORATION_BEGUN';
      description = 'CREWS_PATROLLING';
      break;

    case PspsStatus.NoAlerts:
      title = 'NO_CURRENT_ALERTS';
      description = 'PSPS_CAN_OCCUR_ANYWHERE_ANYTIME';
      break;

    default:
      break;
  }

  if (
    pspsDetails?.status === null ||
    pspsDetails?.status === undefined ||
    pspsDetails?.status === PspsStatus.NoAlerts
  ) {
    return null;
  }

  return (
    <>
      <ScheduledOutageCard
        pspsHeader={t(title)}
        description={inlineRichT(description)}
      />
    </>
  );
};
